import axios from "axios";
import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const EventTokenPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  useEffect(() => {
    if (token) {
      async function tokenApiCall() {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/v1/CoordinatorManagement/Approve-Event-Booking-Management`,
          {
            token,
          }
        );
        if (response.status === 200) {
          // Redirect to login page upon successful API call
          navigate("/login");
        } else {
          console.error("Unexpected response:", response);
        }
      }

      tokenApiCall();
    }
  }, [token, navigate]);

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Main Content */}
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div
          className="spinner-border text-primary"
          style={{ width: "4rem", height: "4rem" }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default EventTokenPage;
